// extracted by mini-css-extract-plugin
export default {"wrapper":"tickets_wrapper__WX0-Y","container":"tickets_container__ZA0VJ","table":"tickets_table__naHin","head_Card":"tickets_head_Card__hW-UZ"};